import { isEpmty } from "../../../helper/TextHelper";
import { httpClient } from "./RestService";

export const create = async (request) => {
  return await httpClient().post("/v1/education/instructor/casestudy", request);
};

export const submitReview = async (request) => {
  return await httpClient().put("/v1/education/instructor/casestudy", request);
};

export const upsertBaseInfo = async (request) => {
  if (isEpmty(request.id)) {
    // insert
    return await httpClient().post(
      "/v1/education/instructor/casestudy/binf",
      request
    );
  } else {
    // update
    return await httpClient().put(
      "/v1/education/instructor/casestudy/binf",
      request
    );
  }
};

export const getAll = async (courseId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/list/" + courseId
  );
};

export const getCaseStudyPurchaseClientSecret = async (data) => {
  return httpClient().post("/v1/education/payment/cs/casepurchase", data);
};

export const getTeachingNotes = async (caseStudyId) => {
  return await httpClient(true).get(
    "/v1/education/instructor/casestudy/tn/" + caseStudyId
  );
};

export const createTeachingNote = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/tn",
    request
  );
};

export const getPdf = async (caseStudyId, paymentStatus, caseStudyType) => {
  return await httpClient(true).get(
    "/v1/education/instructor/casestudy/pdf/" +
      caseStudyId +
      "?ps=" +
      paymentStatus +
      "&csType=" +
      caseStudyType
  );
};

export const del = async (id) => {
  return await httpClient().delete("/v1/education/instructor/casestudy/" + id);
};

export const getIndustryTypes = async (params) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/industry/list",
    {
      params,
    }
  );
};

export const industryDescription = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/industry/description/" + caseStudyId
  );
};

export const createIndustryDescription = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/industry/desc",
    request
  );
};

// Deprecated(since="standard case study added")
export const getIndustryDescription = async (
  caseStudyId,
  industry,
  marketTerritory,
  concept,
  field,
  companyName,
  province
) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/industry/desc?caseStudyId=" +
      caseStudyId +
      "&industry=" +
      industry +
      "&marketTerritory=" +
      marketTerritory +
      "&concept=" +
      concept +
      "&field=" +
      field +
      "&companyName=" +
      companyName +
      "&province=" +
      province
  );
};

// Deprecated(since="standard case study added")
export const updateIndustryDescription = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/industry/desc",
    request
  );
};

export const updateIndustryDescriptionNew = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/industry/description",
    request
  );
};

export const industryTrends = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/industry/trnd/" + caseStudyId
  );
};

export const createIndustryKeyTrends = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/industry/trends",
    request
  );
};

// Deprecated(since="standard case study added")
export const getIndustryKeyTrends = async (
  caseStudyId,
  industry,
  marketTerritory,
  country,
  province,
  field,
  concept,
  companyName
) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/industry/trends?caseStudyId=" +
      caseStudyId +
      "&industry=" +
      industry +
      "&marketTerritory=" +
      marketTerritory +
      "&country=" +
      country +
      "&province=" +
      province +
      "&field=" +
      field +
      "&concept=" +
      concept +
      "&companyName=" +
      companyName
  );
};

// Deprecated(since="standard case study added")
export const updateIndustryKeyTrends = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/industry/trends",
    request
  );
};

export const updateIndustryKeyTrendsNew = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/industry/trnd",
    request
  );
};

export const getCompanyNames = async (params) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/list",
    { params }
  );
};

export const getCompanyNamesOld = async (
  caseStudyId,
  industry,
  country,
  province,
  marketType
) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/list?caseStudyId=" +
      caseStudyId +
      "&industry=" +
      industry +
      "&country=" +
      country +
      "&province=" +
      province +
      "&marketType=" +
      marketType
  );
};

export const getConcept = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/concept",
    request
  );
};

export const getIndustryName = async (params) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/industry/name",
    { params }
  );
};

// Deprecated(since="standard case study added")
export const getCompanyBackground = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/company/bg",
    request
  );
};

export const createCompanyHistory = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/company/history",
    request
  );
};

export const updateCompanyHistory = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/history",
    request
  );
};

export const companyHistory = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/history/" + caseStudyId
  );
};

// Deprecated(since="standard case study added")
export const updateCompanyBackground = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/bg",
    request
  );
};

// Deprecated(since="standard case study added")
export const getCompanyCompetitiveAdvantage = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/company/compadv",
    request
  );
};

// Deprecated(since="standard case study added")
export const updateCompetitiveAdvantage = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/compadv",
    request
  );
};

export const createCompetitiveAdvantage = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/company/competad",
    request
  );
};

export const updateCompetitiveAdvantageNew = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/competad",
    request
  );
};

export const competitiveAdvantage = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/competad/" + caseStudyId
  );
};

// Deprecated(since="standard case study added")
export const getMarketSegment = async (caseStudyId, companyName, country) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/mseg?companyName=" +
      companyName +
      "&country=" +
      country +
      "&caseStudyId=" +
      caseStudyId
  );
};

// Deprecated(since="standard case study added")
export const updateMarketSegment = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/mseg",
    request
  );
};

export const createMarketAnalysis = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/company/marketanl",
    request
  );
};

export const updateMarketAnalysis = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/marketanl",
    request
  );
};

export const marketAnalysis = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/marketanl/" + caseStudyId
  );
};

export const getProductAndServices = async (companyName, country, province) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/prodsvc?companyName=" +
      companyName +
      "&country=" +
      country +
      "&province=" +
      province
  );
};

export const getCompanyBrands = async (
  caseStudyId,
  companyName,
  marketTerritory,
  province
) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/brands?caseStudyId=" +
      caseStudyId +
      "&companyName=" +
      companyName +
      "&marketTerritory=" +
      marketTerritory +
      "&province=" +
      province
  );
};

export const updateBrands = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/brands",
    request
  );
};

// Deprecated(since="standard case study added")
export const getCompanyCompetitorsAnalysis = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/company/compAnalysis",
    request
  );
};

export const createCompetitorsAnalysis = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/company/competitoranl",
    request
  );
};

export const updateCompetitorsAnalysisNew = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/competitoranl",
    request
  );
};

export const competitorAnalysis = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/competitoranl/" + caseStudyId
  );
};

// Deprecated(since="standard case study added")
export const updateCompetitorsAnalysis = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/company/compAnalysis",
    request
  );
};

export const getTopics = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/topic/list",
    request
  );
};

export const getSubTopics = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/topic/sub",
    request
  );
};

export const getCompetitos = async (params) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/company/compts",
    { params }
  );
};

export const getBizFactors = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/biz/factors",
    request
  );
};

// Deprecated(since="standard case study added")
export const getMacroAnalysis = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/biz/macro/analysis",
    request
  );
};

export const createMacroAnalysis = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/biz/macroanl",
    request
  );
};

export const updateMacroAnalysisNew = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/biz/macroanl",
    request
  );
};

export const macroAnalysis = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/biz/macroanl/" + caseStudyId
  );
};

// Deprecated(since="standard case study added")
export const updateMacroAnalysis = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/biz/macro/analysis",
    request
  );
};

// Deprecated(since="standard case study added")
export const getMicroAnalysis = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/biz/micro/analysis",
    request
  );
};

export const createMicroAnalysis = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/biz/microanl",
    request
  );
};

export const updateMicroAnalysisNew = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/biz/microanl",
    request
  );
};

export const microAnalysis = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/biz/microanl/" + caseStudyId
  );
};

// Deprecated(since="standard case study added")
export const updateMicroAnalysis = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/biz/micro/analysis",
    request
  );
};

// Deprecated(since="standard case study added")
export const getTitleAndIntroduction = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/introTitle",
    request
  );
};

export const titleAndIntroduction = async (id) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/introTitle/" + id
  );
};

export const updateIntro = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/introduction",
    request
  );
};

// Deprecated(since="standard case study added")
export const updateIntroduction = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/intro",
    request
  );
};

export const updateTitle = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/title",
    request
  );
};

export const createProblemStory = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/problem",
    request
  );
};

export const getProblemStory = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/problem?caseStudyId=" + caseStudyId
  );
};

export const decisionPoint = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/cs/mini/dp/" + caseStudyId
  );
};

export const updateDecisionPoint = async (request) => {
  return await httpClient().put("/v1/education/instructor/cs/mini/dp", request);
};

export const options = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/cs/mini/opt/" + caseStudyId
  );
};

export const updateOption = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/cs/mini/opt",
    request
  );
};

export const situationBackground = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/cs/mini/sitbk/" + caseStudyId
  );
};

export const updateSituationBackground = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/cs/mini/sitbk",
    request
  );
};

export const updateMiniCaseDecisionPoint = async (request) => {
  return await httpClient().put("/v1/education/instructor/cs/mini/dp", request);
};

// @Deprecated(since = "user cannot change this for mini or standard case")
export const getProblemStoryFactor = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/cs/prbl/str/fact?caseStudyId=" + caseStudyId
  );
};

// @Deprecated(since = "user cannot change this for mini or standard case")
export const deleteProblemFactor = async (id) => {
  return await httpClient().delete(
    "/v1/education/instructor/cs/prbl/str/fact/" + id
  );
};

// @Deprecated(since = "user cannot change this for mini or standard case")
export const updateFactorStrategy = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/cs/prbl/str/fact/strategy",
    request
  );
};

// @Deprecated(since = "user cannot change this for mini or standard case")
export const updateFactorProblems = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/cs/prbl/str/fact/pblm",
    request
  );
};

// Deprecated
export const updateProblem = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/problem",
    request
  );
};

export const updateProblemTitle = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/problem/title",
    request
  );
};

export const deleteProblem = async (id) => {
  return await httpClient().delete(
    "/v1/education/instructor/casestudy/problem/" + id
  );
};

export const updateProblemStory = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/problem/story",
    request
  );
};

export const deleteProblemStory = async (id) => {
  return await httpClient().delete(
    "/v1/education/instructor/casestudy/problem/story/" + id
  );
};

// Deprecated(since="standard case study added")
export const getQuestions = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/qs",
    request
  );
};

export const createQuestions = async (request) => {
  return await httpClient().post(
    "/v1/education/instructor/casestudy/question",
    request
  );
};

export const updateQuestion = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/question",
    request
  );
};

export const existingQuestions = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/instructor/casestudy/question/" + caseStudyId
  );
};

// Deprecated(since="standard case study added")
export const updateQuestions = async (request) => {
  return await httpClient().put(
    "/v1/education/instructor/casestudy/qs",
    request
  );
};

export const getPaymentOptions = async () => {
  return await httpClient().get("/v1/education/casestudy/purchase/options");
};

export const isUserEligibleToShare = async () => {
  return await httpClient().get(
    "/v1/education/casestudy/purchase/options/elg/share"
  );
};
